var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('HomePageBaner',{attrs:{"title":_vm.banerTitle,"text":_vm.banerText}}),_c('TeamPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }